import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { IViewerStore } from './viewer.store';
import { ViewerStore } from './viewer.types';

export interface CanvasState {
  pageMode: 'scroll' | 'single';
  selectedPageNumber: number;
  zoom: number;
  viewOptions: 'fit' | 'fill' | null;
  pageDimension: {
    width: number;
    height: number;
  } | null;
}

export interface CanvasActions {
  setPageDimension: (dimensions: ViewerStore['pageDimension']) => void;
  setPageMode: (mode: ViewerStore['pageMode']) => void;
  setSelectedPageNumber: (index: number) => void;
  setViewOptions: (viewOptions: ViewerStore['viewOptions']) => void;
  setZoom: (zoom: ViewerStore['zoom']) => void;
}

export type CanvasSlice = CanvasState & CanvasActions;

export const createCanvasSlice: StateCreator<IViewerStore, [], [], CanvasSlice> = (set) => ({
  pageDimension: null,
  pageMode: 'scroll',
  selectedPageNumber: 1,
  viewOptions: 'fit',
  zoom: 100,
  setPageMode(mode) {
    set(
      produce((draft) => {
        draft.pageMode = mode;
      })
    );
  },
  setSelectedPageNumber: (pageNumber) => {
    set(
      produce((draft) => {
        draft.selectedPageNumber = pageNumber;
      })
    );
  },
  setZoom: (zoom) => {
    set(
      produce((draft) => {
        draft.zoom = Math.round(zoom);
      })
    );
  },
  setViewOptions(viewOptions) {
    set(
      produce((draft) => {
        draft.viewOptions = viewOptions;
      })
    );
  },
  setPageDimension: (dimensions) => {
    set(
      produce((draft) => {
        draft.pageDimension = dimensions;
      })
    );
  },
});
